import t from "./index945.js";
function e() {
  this.__data__ = new t(), this.size = 0;
}
export {
  e as default
};
